<div class="container-fluid">

  <form [formGroup]="poInfoForm">
    <div class="row">
      <div class="col-md-3">
        <mat-form-field>
          <input type="text" matInput [placeholder]="isRCDSS? 'Contract number': 'Purchase Order / Contract number'"
                 formControlName="customer_po_number"
                 required />
          <mat-error *ngIf="poInfoForm.controls.customer_po_number.errors?.exists">
            This number is already registered
          </mat-error>
          <mat-error *ngIf="!poInfoForm.controls.customer_po_number.value">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <ng-select
          ngEditableSelect
          labelForId="supplier_select"
          #supplier_select
          [items]="suppliers"
          bindValue="id"
          bindLabel="name"
          placeholder="Supplier *"
          required
          appendTo="body"
          [clearable]="false"
          [minlength]="2"
          typeToSearchText="Please enter 2 or more characters"
          formControlName="supplier_id"
        >
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div [ngOptionHighlight]="search">
              {{ item.name }}
            </div>
          </ng-template>
          <ng-template ng-footer-tmp>
            <a class="d-block" (click)="addNewCompany(); supplier_select.close();">
              Add new company
            </a>
          </ng-template>
        </ng-select>
      </div>

      <div class="col-md-2">
        <mat-form-field>
          <input
            required
            matInput
            [matDatepicker]="orderDatePicker"
            placeholder="Order date"
            formControlName="order_date"
            (click)="orderDatePicker.open()"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="orderDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #orderDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-md-2">
        <mat-form-field>
          <input
            [required]="true"
            matInput
            [matDatepicker]="shipDatePicker"
            placeholder="Ship date"
            formControlName="ship_date"
            [min]="poInfoForm.controls.order_date.value"
            (click)="shipDatePicker.open()"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="shipDatePicker"></mat-datepicker-toggle>
          <mat-datepicker
            #shipDatePicker
            title="Select an order date first"
          ></mat-datepicker>

          <mat-error *ngIf="poInfoForm.controls.ship_date.errors?.matDatepickerMin">
            Ship date should be greater than the order date
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-2">
        <mat-form-field [ngClass]="{ 'red-border': shouldHighlightCancelDate() }">
          <input
            [required]="true"
            matInput
            [matDatepicker]="cancelDatePicker"
            placeholder="Cancel Date"
            formControlName="cancel_date"
            [min]="poInfoForm.controls.ship_date.value"
            (click)="cancelDatePicker.open()"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="cancelDatePicker"></mat-datepicker-toggle>
          <mat-datepicker
            #cancelDatePicker
            title="Select a ship date first"
          ></mat-datepicker>
          <mat-error *ngIf="poInfoForm.controls.cancel_date.errors?.matDatepickerMin">
            Cancel date should be greater than the ship date
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <mat-form-field>
          <mat-select required placeholder="Priority" formControlName="customer_priority">
            <mat-option *ngFor="let priority of priorities" [value]="priority.id">
              {{ priority.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-3">
        <mat-form-field>
          <mat-select required placeholder="Report Frequency" formControlName="finished_goods_reports_period">
            <mat-option *ngFor="let period of frequencies" [value]="period.value"
                        (click)="getReportPeriod(period)">
              {{ period.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-2">
        <mat-form-field *ngIf="poInfoForm.controls.finished_goods_reports_period.value !== 'No report needed'">
          <input
            required
            matInput
            [matDatepicker]="reportStartDatePicker"
            placeholder="Reports start at"
            formControlName="report_start_date"
            [min]="poInfoForm.controls.order_date.value"
            [max]="poInfoForm.controls.ship_date.value"
            (click)="reportStartDatePicker.open()"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="reportStartDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #reportStartDatePicker></mat-datepicker>
          <mat-error *ngIf="poInfoForm.controls.report_start_date.errors?.matDatepickerMin">
            Report date should be greater than the order date
          </mat-error>
          <mat-error *ngIf="poInfoForm.controls.report_start_date.errors?.matDatepickerMax">
            Report date should be lower than the ship date
          </mat-error>
        </mat-form-field>
      </div>

    </div>
  </form>
  <div class="row">
    <div class="col-md-12">
      <div class="alert alert-warning mb-2 mt-2" *ngIf="!_canSupplierReceivePos">
        <i class="fa fa-warning"></i> The selected supplier has not provided one or more of the Customer-Required Files
        defined by your company. You can keep editing this Purchase Order and save it as a draft, but you won't be able
        to issue it until your supplier fills all file requirements.
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <ngx-title-divider title="Line Items"></ngx-title-divider>
</div>

<form [formGroup]="poLineItemsForm" (ngSubmit)="addLineItem()" #lineItemsForm>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <ng-select
          ngEditableSelect
          #line_item_product_select
          labelForId="line_item_product_id_select"
          [items]="availableProducts"
          bindValue="id"
          bindLabel="name"
          appendTo="body"
          [clearable]="false"
          placeholder="Enter product name or customer part identifier"
          [minlength]="2"
          typeToSearchText="Please enter 2 or more characters"
          formControlName="product_id"
          [searchFn]="searchProduct"
        >
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="d-flex flex-column">
              <div class="flex-grow-1 text-ellipsis">
                <small style="color: #aaa;">Product Name: </small>
                <span [ngOptionHighlight]="search">{{ item.name }}</span>
              </div>
              <div class="flex-grow-1 text-ellipsis" *ngIf="item.customer_part_id">
                <small style="color: #aaa;">Customer Part Identifier: </small>
                <span [ngOptionHighlight]="search">{{ item.customer_part_id }}</span>
              </div>
              <div class="flex-grow-1 text-ellipsis" *ngIf="!item.customer_part_id">
                <small style="color: #aaa;">Customer Part Identifier: </small>
                <span> - </span>
              </div>
            </div>
          </ng-template>
          <ng-template ng-footer-tmp>
            <a class="d-block"
               *ngIf="poInfoForm.controls.supplier_id.value"
               (click)="addProduct(); line_item_product_select.close()">
              Add new product
            </a>
            <div *ngIf="!poInfoForm.controls.supplier_id.value">
              Please select the supplier before add or select line items
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-4">
        <mat-form-field>
          <input type="number" min="1" matInput placeholder="Quantity" formControlName="quantity_ordered"
                 [required]="!lineItems.length" />
        </mat-form-field>
      </div>
      <div class="col-auto d-flex align-self-start">
        <button class="w-100 btn btn-dark" type="submit">
          Add New Item <i class="fa fa-plus"></i>
        </button>
        <button
          [disabled]="!poLineItemsForm.dirty"
          class="ml-1"
          color="warn"
          type="button"
          mat-button
          (click)="resetLineItemsForm()"
        >
          Clear
        </button>
      </div>
    </div>
  </div>
</form>

<div class="container-fluid mt-4" *ngIf="lineItems.length">
  <ngx-line-items-list
    (removeLineItem)="removeLineItem($event.index)"
    (updateLineItem)="updateLineItem($event)"
    [companyType]="'customer'"
    [products]="products"
    [purchaseOrder]="purchaseOrder"
    [allowEdit]="false"
    [allowDelete]="true"
    [lineItems]="lineItems"></ngx-line-items-list>
</div>

<div *ngIf="showStepsButtons">
  <div class="d-flex mt-4 p-2 justify-content-center align-items-center position-relative">
    <button class="ml-1 mr-1" type="button" mat-raised-button color="grey"
            [disabled]="poInfoForm.invalid || !lineItems.length || poLineItemsForm.dirty"
            (click)="saveDraft.emit()">
      Save to Draft
    </button>
    <button class="ml-1 mr-1" [disabled]="poInfoForm.invalid || !lineItems.length || poLineItemsForm.dirty"
            type="button" mat-raised-button color="primary"
            matStepperNext>
      Next
    </button>
    <button class="ml-1 mr-1 button-discard" type="button" mat-raised-button color="warn"
            (click)="discard.emit()">
      <i class="fa fa-trash"></i>
      Discard
    </button>
  </div>
</div>
